var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-slider-wrap"},[_c('ImageSlider',{attrs:{"items":_vm.images},on:{"preview":_vm.openPreview}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }